import PropTypes from 'prop-types';
import React from 'react';
import PropertyFeaturesView from './PropertyFeaturesView';
import PropertyFeaturesForm from './PropertyFeaturesForm';

function getInitialValues(featureList) {
  const initialValues = { features: [] };
  featureList.forEach(feat => {
    initialValues.features.push(feat.key);
  });
  return initialValues;
}

class PropertyFeatures extends React.Component {
  constructor() {
    super();
    this.state = {
      isEditing: false,
    };
    this.handleEdit = this.handleEdit.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  handleEdit() {
    this.setState({ isEditing: true });
  }
  handleClose() {
    this.setState({ isEditing: false });
  }
  handleSubmit(values) {
    const payload = values;
    this.props.editHotelFeatures(this.props.isAddHotel ? this.props.hotel.hotels[0].id : this.props.hotel.id, payload);
    this.handleClose();
  }
  render() {
    const iv = !this.props.isAddHotel && getInitialValues(this.props.hotel.features);
    if (this.state.isEditing || this.props.isAddHotel) {
      return (
        <PropertyFeaturesForm
          {...this.props}
          onSubmit={this.handleSubmit}
          initialValues={iv}
          handleClose={this.handleClose}
        />
      );
    }
    return <PropertyFeaturesView {...this.props} handleEdit={this.handleEdit} />;
  }
}
PropertyFeatures.propTypes = {
  hotel: PropTypes.object.isRequired,
  editHotelFeatures: PropTypes.func.isRequired,
};

export default PropertyFeatures;



// WEBPACK FOOTER //
// src/routes/hotels/components/PropertyFeatures.js